import React from 'react'
import Header from '../../components/header/Header'
import PageHeading from '../../components/pageHeading/PageHeading'
import Footer from '../../components/footer/Footer'
import './about.scss'

import { CheckMarkIcon } from '../../components/Icons'
import AboutImg1 from '../../assets/images/about-1.jpg'
import AboutImg2 from '../../assets/images/about-2.jpg'
import { Button } from 'react-bootstrap'
import SelectDateTime from '../../customer/selectDateTime/SelectDateTime'
import { useEffect, useState } from 'react'
import { getContent, getAllContent } from '../../services/auth.service'
import { useSelector, useDispatch } from "react-redux";
import { setLoader } from '../../slice/commonSlice'


const AboutUs = () => {
    const [contentId, setContentId] = useState();
    const [content, setContent] = useState([]);
    const dispatch = useDispatch();

    const getallcontent = async () => {
        const result = await getAllContent();
        const searchObject = result.data.find((data) => data.slug == "aboutUs");
        setContentId(searchObject._id)
    }

    const getcontent = async () => {
        // const paylaod = { "_id": contentId }
        // const result = await getContent(paylaod);
        // console.log(result,"all ther result")
        // setContent(result.data.content)

        // return
        try {
            await dispatch(setLoader(true));
            const paylaod = { "_id": contentId }
            const result = await getContent(paylaod);
            if (result?.status === 200) {
                setContent(result.data.content)
                console.log("result.data.content", result.data.content)
                await dispatch(setLoader(false));
            } else {
                await dispatch(setLoader(false));
            }
        } catch (e) {
            await dispatch(setLoader(false));
            console.log("error", e);

        }
    }

    useEffect(() => {
        getallcontent();
    }, []); // Empty dependency array ensures it runs only once
    

    useEffect(() => {
        if (contentId) {
            getcontent();
        }
    }, [contentId]);
    

    return (
        <>
            <Header />
            <PageHeading title="About us" />
            <div className='main-container'>
                <div className='container-wrap'>
                    <div className='about-container-wrap'>
                        {content.map((item) => {
                            return (
                                <div key={item._id} className='about-content'>
                                    <div className='about_title'>{item.question}</div>
                                    <p className='about_info'>{item.answer}</p>
                                </div>
                            )
                        })}

                    </div>
                </div>
            </div>
            <Footer />

        </>
    )
}

export default AboutUs